import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Flex } from "antd";
import { getBannerAPI } from "api/banner";
import { useEffect, useState } from "react";

export const QuickMenu = () => {
  const [isOpen, setIsOpen] = useState(true)
  const [list, setList] = useState(null)

  const fnGetList = async () => {
    try {
      const { data } = await getBannerAPI()
      const { data_list } = data
      const filterList = data_list?.filter(it => it.DISPLAY_YN)
      setList(filterList)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    fnGetList()
  }, [])

  return (
    isOpen ?
      <Flex className="quick-menu" vertical={true}>
        <div className="quick-menu-inner-wrap">
          <div className="quick-menu-item" onClick={() => setIsOpen(false)}>
            <RightOutlined />
          </div>
          {list?.map(it => 
            <div 
              className="quick-menu-item" 
              onClick={() => window.open(it?.BANNER_URL, '_blank', `width=${it.BANNER_SIZE_W},height=${it.BANNER_SIZE_H},top=${it.BANNER_POSITION_H},left=${it.BANNER_POSITION_W}`)}
            >
              <div>{it?.BANNER_NAME}</div>
            </div>
          )}

        </div>
      </Flex>
      :
      <Flex className="quick-menu-open">
        <div className="quick-menu-open-item" onClick={() => setIsOpen(true)}>
          <LeftOutlined />
        </div>
      </Flex>
  )
}
